
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/assembly-chunav/assam/candidates/[candidate]",
      function () {
        return require("private-next-pages/elections/assembly-chunav/assam/candidates/[candidate].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/assembly-chunav/assam/candidates/[candidate]"])
      });
    }
  